import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withProgress } from '../modules/progress'
import { keys, mapKeys, map } from 'lodash'
import './current-progress.css'


@withRouter
@withProgress
export default class extends React.Component<any, any>{


    componentWillMount(){
        if(this.props.progress == null) throw("current-progress.tsx requires modules/progress/progress-reducer")
    }


    getProgressGroup(){
        const currentPath = this.props.location.pathname;
        const groups = this.props.progress.groups;
        for(var i = 0; i < groups.length; i++){
            var group = groups[i];
            if(keys(group).indexOf( currentPath ) != -1){
                return group;
            }
        }
        return null;
    }

    
    item(path, description){
        const indexOfActive = keys( this.getProgressGroup() ).indexOf(this.props.location.pathname);
        const thisIndex = keys( this.getProgressGroup() ).indexOf(path);
        const className = "pill " + (path === this.props.location.pathname ? "pill-active" : "hidden-sm-down") + (thisIndex > indexOfActive ? " faded" : "")
        return <div key={ path } className={ className }>{ description }</div>
    }


    render(){
        const group = this.getProgressGroup() || []; 
        const hidePillsWhenSm = this.props.hidePillsWhenSm;

        if(group.length == 0) return null;

        return(
            <div className="current-progress">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className={`pills-container ${ hidePillsWhenSm ? "hidden-sm-down" : "" }`}>{ map(keys(group), path => this.item(path, group[path]))  } </div>
                            { this.props.extra && <div className="current-progress-extra hidden-md-up">{ this.props.extra }</div> }
                            { this.props.extra && <div className="current-progress-extra float-right">{ this.props.extra }</div> }
                        </div>
                    </div>
                </div>
            </div>
        )
        
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/current-progress.tsx